import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import appSettings from 'apps/services/config';
import { AppController } from './app.controller';
import { AppService } from './app.service';
import { Logs } from './logs/logs.entity';
import { LogsModule } from './logs/logs.module';
@Module({
  imports: [
    TypeOrmModule.forRoot({
      type: 'mysql',
      host: appSettings.dbhost,
      port: 3306,
      username: appSettings.dbuser,
      password: appSettings.dbpassword,
      database: appSettings.logs_db,
      synchronize: false,
      logging: true,
      entities: [Logs],
    }
    ),
    TypeOrmModule.forFeature([Logs]),
    LogsModule
  ],
  controllers: [AppController],
  providers: [AppService,],
})
export class AppModule { }